export class AdditionalFilter {
  field: string;
  value: any;

  constructor(init: Readonly<AdditionalFilter>) {
    Object.assign(this, init);
  }
}
